import React, { useRef, useEffect } from "react";

const AboutSection = () => {
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const imageRef = useRef(null);
  const isIntersecting = useRef(false);

  useEffect(() => {
    const currentSectionRef = sectionRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !isIntersecting.current) {
          isIntersecting.current = true;
          if (contentRef.current) {
            contentRef.current.classList.add("slideIn");
          }
          if (imageRef.current) {
            imageRef.current.classList.add("slideInImage");
          }
          observer.unobserve(currentSectionRef); // Stop observing after animation
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.5, // Adjust threshold as needed
      }
    );

    if (currentSectionRef) {
      observer.observe(currentSectionRef);
    }

    return () => {
      if (currentSectionRef) {
        observer.unobserve(currentSectionRef);
      }
    };
  }, []);

  return (
    <section className="about-section" ref={sectionRef}>
      <div className="about-content" ref={contentRef}>
        <h2 className="about-title">About Us</h2>
        {/* <hr className="about-divider" /> */}
        <div className="text-scroll-container">
          <p className="about-paragraph">
            Ethiccraft Club, officially launched by former HRD Minister Mr. Prakash Javadekar on 14th October 2018 at IGI Stadium. It is dedicated to empowering the youth of India by focusing on values and social well-being. The idea was brought to life by a team of selfless and hardworking young individuals who envisioned a platform that supports and uplifts students through a blend of knowledge and timeless wisdom, providing them with a much-needed support system and inspiring environment.
          </p>
          <p className="about-paragraph">
            The club recognizes that values are not just a foundation for society but the very basis of human existence. With this understanding, Ethiccraft aims to help young people discover and cultivate essential values, enabling them to refine their character and experience the joy of self-awareness. It also serves as a platform for youth to express the innate goodness within their hearts by becoming instruments of positive change in the lives of other
          </p>
        </div>
      </div>
      <div className="about-image" ref={imageRef}>
        <div className="image-overlay">
          <img
            src="/assets/About/About.jpg"
            alt="Ethiccraft Students"
            className="about-img"
          />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;